import React from 'react';
import { Contact } from '../Contact';
import { CTA } from '../CTA';
export const AboutPage = () => {
  return <div className="w-full bg-white" data-id="element-174">
      <Contact data-id="element-175" />
      <CTA data-id="element-176" />
    </div>;
};